import axios from "@/axios/index";
export function doLogin(user,pass){
    return axios.post("/api/client/login",{username:user,password:pass})
}
export function doRegister(user,password,adminId){
    return axios.post("/api/client/register",{username:user,password:password,adminId:adminId})
}

